import {
  ButtonGroup,
  ButtonGroupCloseColorEnum,
  ButtonGroupCornerEnum,
  ButtonSizeEnum,
  FontColorEnum,
  FontSizeEnum,
  FontWeightEnum,
  IconSizeEnum,
  Tooltip,
  Typography,
} from '@acceso/design-system';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

import { REVIEW_STATES, TReviewStates } from '@/constants';
import { ReviewStateEnum } from '@/features/segments/types';
import { useProgramBroadcastFilters } from '@/stores/program-broadcast-filters';

export function BroadcastScheduleProgramHeaderButtonFiltersReview<T = ReviewStateEnum>({
  reviewStates = REVIEW_STATES as unknown as TReviewStates<T>[],
}: {
  reviewStates?: TReviewStates<T>[];
}) {
  const { review_states, setFilters } = useProgramBroadcastFilters();
  const { t } = useTranslation();

  const handleReviewStateChange = (state: number) => {
    if (review_states.includes(state)) {
      setFilters({ review_states: review_states.filter(p => p !== state) });
    } else {
      setFilters({ review_states: [...review_states, state] });
    }
  };
  return (
    <div className="flex items-center gap-2">
      {reviewStates.map(item => {
        const itemValue = item.value as unknown as number;

        return (
          <Tooltip help={t(item.label)} key={itemValue} grow>
            <ButtonGroup
              size={ButtonSizeEnum.SM}
              onClick={() => handleReviewStateChange(itemValue)}
              onClickClose={() => handleReviewStateChange(itemValue)}
              closeColor={ButtonGroupCloseColorEnum.PRIMARY}
              isFilled={review_states.includes(itemValue)}
              corner={ButtonGroupCornerEnum.FULL}
              className={clsx(
                'hover:!bg-neutral-20',
                review_states.includes(itemValue)
                  ? '!border-[2px] !border-accent-active-primary-20 bg-extra-new-95'
                  : '!border'
              )}
              closeIcon={review_states.includes(itemValue)}
            >
              <Typography
                fontSize={FontSizeEnum.Basic}
                weight={FontWeightEnum.Semibold}
                color={FontColorEnum.Dark10}
              >
                {<item.icon size={IconSizeEnum.SM} className={item.color} />}
              </Typography>
            </ButtonGroup>
          </Tooltip>
        );
      })}
    </div>
  );
}
